<template>
  <div>
    <Breadcrumb :dataSource="breadcrumbList" />
    <div class="page-container">
      <TableList
        style="min-height: 80vh"
        :columns="columns"
        :tableData="dataSource"
        :loading="loading"
        :scroll="{}"
        :pagination="ipagination"
        @change="handleTableChange"
      >
        <div slot="queryArea" style="margin-bottom: 20px">
          <a-select
            v-model="queryParam.evaluationId"
            :options="evalOptions"
            placeholder="请选择测评"
            style="width: 140px; margin-right: 15px"
            allowClear
          />
          <j-dict-select-tag
            placeholder="请选择年级"
            v-model="queryParam.gradeId"
            style="width: 140px; margin-right: 15px"
            dictCode="school_grade,grade_name,id,0=delete_flag order by sort_order"
            allowClear
          />
          <j-dict-select-tag
            placeholder="请选择班级"
            v-model="queryParam.classId"
            style="width: 140px; margin-right: 15px"
            :dictCode="
              'school_class,name,id,grade_id=' + (!queryParam.gradeId ? -1 : queryParam.gradeId)"
            :disabled="!queryParam.gradeId"
            :async="true"
          />
      
          <a-range-picker
            v-model="rangeDate"
            style="width: 220px; margin-right: 15px"
            @change="changeDateRange"
          />
          <j-dict-select-tag
            v-model="queryParam.careList"
            placeholder="关爱等级"
            dictCode="care_list"
            style="width: 140px; margin-right: 15px"
          />
          <a-input-search
            v-model="queryParam.name"
            placeholder="请输入学生名称"
            style="width: 170px; margin-right: 15px"
            @change="searchName"
          />
          <a-button type="primary" @click="loadData(1)">查询</a-button>
          <!-- <a-button type="primary" icon="plus">新增</a-button> -->
          <!--<a-button type="primary" icon="download" style="margin: 0 15px" @click="handleExportXls">-->
          <!--  导出-->
          <!--</a-button>-->
        </div>
        <!--<template slot="action" slot-scope="{ record }">-->
        <!--  <div class="action-detail">-->
        <!--    <span @click="showAddLabel(record)">+标签</span>-->
        <!--    <a-divider type="vertical" />-->
        <!--    <span @click="viewArchives(record)">查看档案</span>-->
        <!--  </div>-->
        <!--</template>-->
      </TableList>
      <!-- 评估 -->
      <AssessModal ref="assessModalRef" />
      <AddLabelModal ref="addLabelModalRef" @close="loadData" />
    </div>
  </div>
</template>
<script>
import TableList from '@/components/chart/TableList'
import { getAction } from '@api/manage'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import { simpleDebounce } from '@/utils/util'
import AssessModal from '@/comUi/AssessModal'
import AddLabelModal from '@/comUi/AddLabelModal'
import Breadcrumb from '@/components/Breadcrumb/index'
import moment from 'moment'

export default {
  name: 'PsyEvaluatNum',
  mixins: [JeecgListMixin],
  components: {
    TableList,
    AssessModal,
    AddLabelModal,
    Breadcrumb,
  },
  data() {
    return {
      tabKey: 1,
      queryParam: {},
      rangeDate: [],
      breadcrumbList: [
        {
          label: '心理工作概览',
          isBack: true,
        },
        {
          label: '心理测评次数',
        },
      ],
      columns: [
        {
          title: '序号',
          dataIndex: 'index',
          align: 'center',
        },
        {
          title: '心理测评名称',
          dataIndex: 'name',
          align: 'center',
          customRender: (_, record) => {
            return '学生测评'
          },
        },
        {
          title: '班级',
          dataIndex: 'studentClass',
          align: 'center',
          customRender: (_, record) => {
            return record.schoolClass.name || ''
          },
        },
        {
          title: '教师名称',
          dataIndex: 'careList_dictText',
          align: 'center',
          customRender: (_, record) => {
            return record.schoolClass.teacherName
          },
        },
        {
          title: '未完成学生',
          dataIndex: 'warnCnt',
          align: 'center',
          customRender: () => {
            return 8
          },
        },
        {
          title: '已完成学生',
          dataIndex: 'tutorCnt',
          align: 'center',
          customRender: () => {
            return 43
          },
        },
        // {
        //   title: '操作',
        //   dataIndex: 'action',
        //   align: 'center',
        //   scopedSlots: { customRender: 'action' },
        // },
      ],
      url: {
        list: '/aigoes/studentInfo/list',
        exportXlsUrl: '/aigoes/studentInfo/exportXls',
      },
      warnCategoryOpts: [
        {
          label: '全部',
          value: 0,
        },
        {
          label: '重点关爱学生',
          value: 1,
        },
        {
          label: '提醒学生',
          value: 2,
        },
      ],
      warnLvOpts: [
        {
          label: '正常',
          value: 0,
        },
        {
          label: '一级',
          value: 1,
        },
        {
          label: '二级',
          value: 2,
        },
        {
          label: '三级',
          value: 3,
        },
      ],
      evalOptions: [],
    }
  },
  // created() {
  //   this.loadData()
  // },
  mounted() {
    this.getEvalOptions()
  },
  computed: {
    importExcelUrl: function () {
      return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`
    },
  },
  methods: {
    // 查询
    queryTable() {
      console.log('查询条件--', this.queryParam)
      this.loadData()
    },
    searchName: simpleDebounce(function (event) {
      console.log('搜索条件--', event.target.value)
      const name = event.target.value
    }, 500),
    changeDateRange(date) {
      this.queryParam.beginDate = date[0] ? moment(date[0]).format('YYYY-MM-DD') : undefined
      this.queryParam.endDate = date[1] ? moment(date[1]).format('YYYY-MM-DD') : undefined
    },
    getEvalOptions() {
      getAction('/schoolEvaluation/list', { pageNo: 1, pageSize: 100 }).then((res) => {
        console.log('获取列表数据--', res)
        if (res.success) {
          this.evalOptions =
            res.result.records?.map((item) => ({
              value: item.id,
              label: item.name,
            })) || []
        }
      })
    },
    showAddLabel(record) {
      const recordData = {
        studentId: record.studentNo,
        beginDate: this.queryParam.beginDate,
        endDate: this.queryParam.endDate,
      }
      this.$refs.addLabelModalRef.show(recordData)
    },
    viewArchives(record) {
      console.log('查看档案：', record)
      this.$router.push({
        path: '/school/mentalHealth/ArchivesViewPage',
        query: {
          studentId: record.studentId || record.studentNo,
          pageName: '一生一档',
        },
      })
    },
  },
}
</script>
<style scoped lang="less">
.action-detail {
  min-width: 100px !important;
  color: #0077fa !important;
  cursor: pointer !important;
}
</style>
